export const MIME_TYPE_IMAGE_PNG: string = 'image/png';
export const MIME_TYPE_IMAGE_JPEG: string = 'image/jpeg';
export const MIME_TYPE_IMAGE_JPG: string = 'image/jpg';
export const MIME_TYPE_IMAGE_GIF: string = 'image/gif';
export const MIME_TYPE_IMAGE_BMP: string = 'image/bmp';
export const MIME_TYPE_IMAGE_WEBP: string = 'image/webp';
export const MIME_TYPE_IMAGE_TIFF: string = 'image/tiff';
export const MIME_TYPE_IMAGE_WMF: string = 'image/wmf';
export const MIME_TYPE_IMAGE_EMF: string = 'image/emf';
export const MIME_TYPE_IMAGE_SVG_XML: string = 'image/svg+xml';
export const MIME_TYPE_IMAGE_VND_MICROSOFT_ICON: string = 'image/vnd.microsoft.icon';
export const MIME_TYPE_TEXT_CSV: string = 'text/csv';
export const MIME_TYPE_TEXT_COMMA_SEPARATED_VALUES: string = 'text/comma-separated-values';
export const MIME_TYPE_TEXT_HTML: string = 'text/html';
export const MIME_TYPE_TEXT_XML: string = 'text/xml';
export const MIME_TYPE_TEXT_PLAIN: string = 'text/plain';
export const MIME_TYPE_TEXT_MESSAGE_RFC822: string = 'message/rfc822';
export const MIME_TYPE_TEXT_MULTIPART_RELATED: string = 'multipart/related';
export const MIME_TYPE_APPLICATION_X_MIMEARCHIVE: string = 'application/x-mimearchive';
export const MIME_TYPE_APPLICATION_JSON: string = 'application/json';
export const MIME_TYPE_APPLICATION_PDF: string = 'application/pdf';
export const MIME_TYPE_APPLICATION_RTF: string = 'application/rtf';
export const MIME_TYPE_APPLICATION_MS_EXCEL: string = 'application/msexcel';
export const MIME_TYPE_APPLICATION_VND_MS_EXCEL: string = 'application/vnd.ms-excel';
export const MIME_TYPE_APPLICATION_VND_MS_EXCEL_SHEET_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-excel.sheet.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-excel.sheet.binary.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MS_EXCEL_TEMPLATE_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-excel.template.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MS_EXCEL_ADDIN_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-excel.addin.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_OPENXML_SPREADSHEET_SHEET: string = 'application/'
  + 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const MIME_TYPE_APPLICATION_VND_OPENXML_SPREADSHEET_TEMPLATE: string = 'application/'
  + 'vnd.openxmlformats-officedocument.spreadsheetml.template';
export const MIME_TYPE_APPLICATION_MSWORD: string = 'application/msword';
export const MIME_TYPE_APPLICATION_VND_MSWORD_DOCUMENT_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-word.document.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MSWORD_TEMPLATE_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-word.template.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_OPENXML_WORD_DOCUMENT: string = 'application/'
  + 'vnd.openxmlformats-officedocument.wordprocessingml.document';
export const MIME_TYPE_APPLICATION_VND_OPENXML_WORD_TEMPLATE: string = 'application/'
  + 'vnd.openxmlformats-officedocument.wordprocessingml.template';
export const MIME_TYPE_APPLICATION_MS_POWERPOINT: string = 'application/mspowerpoint';
export const MIME_TYPE_APPLICATION_VND_MS_POWERPOINT: string = 'application/vnd.ms-powerpoint';
export const MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-powerpoint.presentation.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-powerpoint.template.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-powerpoint.slideshow.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_ADDIN_MACRO_ENABLED: string = 'application/'
  + 'vnd.ms-powerpoint.addin.macroEnabled.12';
export const MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_PRESENTATION: string = 'application/'
  + 'vnd.openxmlformats-officedocument.presentationml.presentation';
export const MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_TEMPLATE: string = 'application/'
  + 'vnd.openxmlformats-officedocument.presentationml.template';
export const MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_SLIDESHOW: string = 'application/'
  + 'vnd.openxmlformats-officedocument.presentationml.slideshow';
export const MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_TEXT: string = 'application/vnd.oasis.opendocument.text';
export const MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_SPREADSHEET: string = 'application/'
  + 'vnd.oasis.opendocument.spreadsheet';
export const MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_PRESENTATION: string = 'application/'
  + 'vnd.oasis.opendocument.presentation';
export const MIME_TYPE_APPLICATION_MSACCESS: string = 'application/msaccess';
export const MIME_TYPE_APPLICATION_VND_MS_OFFICE_CALX: string = 'application/vnd.ms-office.calx';
export const MIME_TYPE_APPLICATION_MSPROJECT: string = 'application/msproject';
export const MIME_TYPE_APPLICATION_PBIT: string = 'application/pbit';
export const MIME_TYPE_APPLICATION_PBIX: string = 'application/pbix';
export const MIME_TYPE_APPLICATION_MSWRITE: string = 'application/mswrite';
export const MIME_TYPE_APPLICATION_VND_MS_WORKS: string = 'application/vnd.ms-works';
export const MIME_TYPE_APPLICATION_X_MS_WORKS_WP: string = 'application/x-msworks-wp';
export const MIME_TYPE_APPLICATION_VND_MS_XPS_DOCUMENT: string = 'application/vnd.ms-xpsdocument';
export const MIME_TYPE_APPLICATION_OXPS: string = 'application/oxps';
export const MIME_TYPE_APPLICATION_DBF: string = 'application/dbf';
export const MIME_TYPE_APPLICATION_X_DIF: string = 'application/x-dif';
export const MIME_TYPE_APPLICATION_X_SYLK: string = 'application/x-sylk';
export const MIME_TYPE_APPLICATION_VND_MS_OFFICETHEME: string = 'application/application/vnd.ms-officetheme';
export const MIME_TYPE_APPLICATION_X_7Z_COMPRESSED: string = 'application/x-7z-compressed';
export const MIME_TYPE_APPLICATION_ZIP: string = 'application/zip';
export const MIME_TYPE_APPLICATION_XML: string = 'application/xml';
export const MIME_TYPE_APPLICATION_XHTML_XML: string = 'application/xhtml+xml';
export const MIME_TYPE_APPLICATION_X_TAR: string = 'application/x-tar';
export const MIME_TYPE_APPLICATION_VND_RAR: string = 'application/vnd.rar';
export const MIME_TYPE_APPLICATION_VND_X_BZIP: string = 'application/x-bzip';
export const MIME_TYPE_APPLICATION_VND_X_BZIP2: string = 'application/x-bzip2';
export const MIME_TYPE_APPLICATION_VND_X_FREEARC: string = 'application/x-freearc';
